// EL AVISO DE QUE LA SESIÓN SE VA A CERRAR.
//
// EN TONO TRANQUILO, NO EN ROJO, y ese es medio arreglo. Que la sesión se
// cierre sola no es un error de quien estaba trabajando: es lo que el
// sistema hace a propósito para que un aparato olvidado en un pasillo no
// quede abierto. En rojo compite con todo lo demás de la pantalla y da a
// entender que algo se rompió.
//
// Es la misma corrección que se le hizo a la pantalla de acceso de la
// consola de operador el 18 de agosto.
//
// DICE LAS TRES COSAS de siempre: qué pasa, por qué, y qué hacer ahora.
// Y lo que hay que hacer es un botón, no una explicación.
import { MINUTOS_DE_AVISO } from '../lib/useInactividad';

export default function AvisoSesion({ segundosRestantes, onSeguirAqui }) {
  if (segundosRestantes === null || segundosRestantes === undefined) return null;

  const m = Math.floor(segundosRestantes / 60);
  const s = segundosRestantes % 60;
  const cuanto = m > 0
    ? `${m}:${String(s).padStart(2, '0')}`
    : `${s} segundo${s === 1 ? '' : 's'}`;

  return (
    <div
      // `status` y no `alert`: un lector de pantalla no debe interrumpir
      // a quien está dictando un conteo para decirle esto.
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-amber-200
                 bg-amber-50 px-4 py-3 shadow-[0_-2px_12px_rgba(0,0,0,.06)]
                 sm:inset-x-auto sm:bottom-4 sm:right-4 sm:max-w-sm
                 sm:rounded-lg sm:border"
    >
      <p className="text-sm font-semibold text-amber-900">
        Tu sesión se cerrará en {cuanto}
      </p>
      <p className="mt-1 text-sm leading-snug text-amber-800">
        Es por seguridad: llevas un rato sin usar TEGO y este equipo podría
        quedar abierto. <strong>No perderás lo que estabas escribiendo</strong>,
        y al volver a entrar regresas a esta misma pantalla.
      </p>
      <button
        type="button"
        onClick={onSeguirAqui}
        className="mt-3 w-full rounded-md bg-amber-900 px-4 py-2 text-sm
                   font-semibold text-amber-50 sm:w-auto"
      >
        Sigo aquí
      </button>
      <p className="mt-2 text-xs text-amber-700">
        También se queda abierta con solo tocar la pantalla o teclear algo.
        El aviso sale {MINUTOS_DE_AVISO} minutos antes.
      </p>
    </div>
  );
}
